<template>
  <v-form>
    <v-progress-linear
      v-if="loading"
      indeterminate
      color="blue"
    ></v-progress-linear>
    <v-card>
      <HeaderDividerBlock headerText="Add New Product"></HeaderDividerBlock>
      <v-container class="pa-6">
        <v-layout row v-if="errors">
          <v-flex>
            <Alert @dismissed="onDismissed" :text="errors"></Alert>
          </v-flex>
        </v-layout>
        <v-row>
          <!-- Product Category -->
          <v-col cols="6">
            <v-col class="pa-0 ma-0">
              <p class="text-title">Product Category*</p>
            </v-col>
            <v-autocomplete
              v-model="form.product_category_id"
              :items="productCategoryOptions"
              item-text="name"
              item-value="id"
              placeholder="Select Product Category*"
              dense
              outlined
              clearable
              required
              @change="onProductCategoryChange"
            />
          </v-col>

          <!-- Product Code -->
          <v-col cols="6">
            <v-col class="pa-0 ma-0">
              <p class="text-title">Product Code*</p>
            </v-col>
            <v-text-field
              outlined
              dense
              v-model="form.product_code"
              required
              placeholder="Enter Product Code*"
            >
            </v-text-field>
          </v-col>

          <!-- Product Name -->
          <v-col cols="6">
            <v-col class="pa-0 ma-0">
              <p class="text-title">Product Name*</p>
            </v-col>
            <v-text-field
              outlined
              dense
              v-model="form.name"
              required
              placeholder="Product Name*"
            >
            </v-text-field>
          </v-col>

          <!-- SKU -->
          <v-col cols="6">
            <v-col class="pa-0 ma-0">
              <p class="text-title">SKU</p>
            </v-col>
            <v-text-field
              outlined
              dense
              v-model="form.sku"
              placeholder="Enter SKU"
            >
            </v-text-field>
          </v-col>

          <!-- Scale -->
          <v-col cols="6">
            <v-col class="pa-0 ma-0">
              <p class="text-title">Unit</p>
            </v-col>
            <v-select
              v-model="form.unit_id"
              :items="formattedUnits"
              item-text="display"
              item-value="id"
              placeholder="Select Unit*"
              dense
              outlined
              clearable
            ></v-select>
          </v-col>

          <!-- Description -->
          <v-col cols="12">
            <v-col class="pa-0 ma-0">
              <p class="text-title">Description</p>
            </v-col>
            <v-textarea
              outlined
              dense
              v-model="form.description"
              placeholder="Description"
            >
            </v-textarea>
          </v-col>

          <!-- Is Bundle (Checkbox) -->
          <!-- <v-col cols="6">
            <v-checkbox 
              v-model="form.is_bundle" 
              label="Is Bundle?" 
              dense>
            </v-checkbox>
          </v-col> -->

          <!-- Is Service (Checkbox) -->
          <v-col cols="6">
            <v-checkbox v-model="form.is_service" label="Is Service?" dense>
            </v-checkbox>
          </v-col>

          <!-- Is Tax Product (Checkbox) -->
          <v-col cols="6">
            <v-col class="pa-0 ma-0">
              <p class="text-title">Applicable Taxes</p>
            </v-col>
            <v-autocomplete
              v-model="form.tax_ids"
              :items="taxesDisplay"
              item-text="display"
              item-value="id"
              placeholder="Applicable Taxes"
              multiple
              chips
              clearable
              outlined
              dense
              class="tax-autocomplete"
            ></v-autocomplete>
            <v-checkbox
              v-model="form.is_tax_product"
              :label="'Is Tax Product?'"
              dense
              :value="form.tax_ids && form.tax_ids.length > 0"
              :disabled="true"
            ></v-checkbox>
          </v-col>

          <!-- Product Status -->
          <v-col cols="6">
            <v-col class="pa-0 ma-0">
              <p class="text-title">Status</p>
            </v-col>
            <v-autocomplete
              v-model="form.status"
              :items="statuses"
              placeholder="Select Status"
              dense
              outlined
              clearable
            ></v-autocomplete>
          </v-col>
        </v-row>
      </v-container>

      <v-divider></v-divider>

      <v-card-actions>
        <v-row>
          <v-col cols="12" md="9" xs="6"></v-col>
          <v-col cols="12" md="3" xs="6">
            <v-btn
              v-if="hasPermission('product.create')"
              large
              color="#00B3FF"
              dark
              depressed
              :loading="loading"
              block
              @click="create()"
              >Create Product</v-btn
            >
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="productCategoryDialog" max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">Add New Product Category</span>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="newProductCategory.name"
            label="Category Name"
            required
            outlined
            dense
          />
          <v-text-field
            v-model="newProductCategory.code"
            label="Category Code"
            required
            outlined
            dense
          />
          <v-textarea
            v-model="newProductCategory.remarks"
            label="Remarks"
            outlined
            dense
          />
          <!-- <v-select
            v-model="newProductCategory.status"
            :items="['ACTIVE', 'INACTIVE']"
            label="Status"
            outlined
            dense
          /> -->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="createProductCategory"
            :disabled="!isProductCategoryValid"
            >Save</v-btn
          >
          <v-btn text @click="productCategoryDialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Snackbars
      :text="successMsg"
      :snackbar="snackbar"
      :color="'success'"
      @classSnackbar="closeSnackbar"
    />
    <Snackbars
      :text="'Validation error please scroll up'"
      :snackbar="snackbarError"
      :color="'red'"
      @closeSnackbar="closeSnackbar"
    />
  </v-form>
</template>

<script>
import Alert from "@/components/shared/Alert";
import { ProductService } from "@/services/product-service";
import { TaxService } from "@/services/tax-service.js";
import { checkError } from "@/config/errors.js";
import Snackbars from "@/components/shared/Snackbars";
import HeaderDividerBlock from "@/components/shared/HeaderDividerBlock";
import { createNamespacedHelpers } from "vuex";
const { mapGetters: mapSettingsGetters } = createNamespacedHelpers("settings");
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  name: "CreateProduct",
  components: {
    Alert,
    Snackbars,
    HeaderDividerBlock,
  },
  data() {
    return {
      form: {
        product_category_id: "",
        product_code: "",
        name: "",
        sku: "",
        description: "",

        unit_id: null,
        is_bundle: false,

        is_service: false,
        is_tax_product: false,
        status: "ACTIVE",
        tax_ids: [],
      },
      productCategoryDialog: false,
      newProductCategory: {
        name: "",
        code: "",
        remarks: null,
        status: "ACTIVE",
      },
      taxes: [],
      product_categories: [],
      scales: [],
      units: [],
      gl_accounts: [],
      statuses: ["ACTIVE", "INACTIVE"],
      snackbar: false,
      snackbarError: false,
      successMsg: "Product has been created successfully",
      errors: null,
      loading: false,
    };
  },
  computed: {
    ...mapSettingsGetters({
      currencyCode: "currencyCode",
    }),
    ...mapGetters({
      hasPermission: "hasPermission",
    }),

    formattedUnits() {
      return this.units.map((unit) => ({
        ...unit,
        display: `${unit.unit_code} (${unit.name})`,
      }));
    },

    productCategoryOptions() {
      return [
        { id: "add_new", name: "➕ Add New Category" },
        ...this.product_categories,
      ];
    },
    taxesDisplay() {
      return this.taxes.map((tax) => ({
        ...tax,
        display: `${tax.name} (${tax.rate}%)`,
      }));
    },
    isProductCategoryValid() {
      return this.newProductCategory.name && this.newProductCategory.code;
    },
  },
  mounted() {
    this.getProductCategories();
    this.getUnits();
    this.getTaxes();
  },
  methods: {
    closeSnackbar() {
      this.snackbar = false;
      this.snackbarError = false;
    },
    onDismissed() {
      this.errors = null;
    },
    getProductCategories() {
      this.loading = true;
      ProductService.getProductCategories()
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.product_categories = response.data.data;
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
    getUnits() {
      // Example of how to load product units
      ProductService.getUnits().then((response) => {
        this.units = response.data;
      });
    },
    getTaxes() {
      this.loading = true;
      TaxService.getTaxes()
        .then((response) => {
          this.taxes = response.data.data || [];
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    onProductCategoryChange(val) {
      if (val === "add_new") {
        this.productCategoryDialog = true;
        this.form.product_category_id = null;
      }
    },
    async createProductCategory() {
      this.loading2 = true;
      try {
        const response = await ProductService.createCategory(
          this.newProductCategory
        );
        if (response.data && response.data.data) {
          this.product_categories.unshift(response.data.data);
          this.form.product_category_id = response.data.data.id;
          this.productCategoryDialog = false;
          this.newProductCategory = {
            name: "",
            status: "ACTIVE",
            code: "",
            remarks: "",
          };
        }
      } catch (err) {
        this.errors = err.response?.data || "Error creating category.";
      } finally {
        this.loading2 = false;
      }
    },

    create() {
      this.loading = true;
      this.form.is_tax_product =
        this.form.tax_ids && this.form.tax_ids.length > 0;
      console.log("this.form : ", this.form);
      this.form.tax_ids = (this.form.tax_ids || []).map((id) => Number(id));
      ProductService.create(this.form)
        .then((response) => {
          this.loading = false;
          if (
            response.statusText === "Created" ||
            response.status === 200 ||
            response.status === 201
          ) {
            this.reset();
            this.snackbar = true;
            this.snackbarError = false;

            setTimeout(() => {
              this.$router.push("/product");
            }, 1000);
          } else {
            this.errors = response.data.errors;
            this.snackbarError = true;
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
          this.snackbarError = true;
        });
    },
    reset() {
      this.form = {
        product_category_id: "",
        product_code: "",
        name: "",
        sku: "",
        description: "",
        unit_id: null,
        is_bundle: false,
        reorder_level: null,

        is_service: false,
        is_tax_product: false,
        status: "ACTIVE",
        tax_ids: [],
      };
    },
  },
};
</script>
<style scoped>
::v-deep .tax-autocomplete .v-input__control {
  min-height: 60px;
}

::v-deep .tax-autocomplete .v-select__selections {
  min-height: 50px;
  align-items: flex-start;
  padding-top: 4px;
  flex-wrap: wrap;
}

::v-deep .tax-autocomplete .v-select__selections input {
  margin-top: 4px;
}

::v-deep .tax-autocomplete .v-chip {
  height: 32px;
  min-height: 32px;
  margin: 7px 4px 2px 0;
}
</style>
